/**
 * StickyFooterPosition.ABSOLUTE is only used for
 * fullscreen modals, callout and drawers which is automatically
 * set if fl-sticky-footer is a content child of fl-sticky-footer-wrapper.
 *
 * This is to fix issues in older IOS versions where position fixed
 * elements inside scrollable containers either shakes or hide during scrolling
 */
export enum StickyFooterPosition {
  ABSOLUTE = 'absolute',
  FIXED = 'fixed',
}

/**
 * To ensure consistency when the parent component's color changes,
 * the sticky footer's background color should match that of the parent.
 * Set the footer's background to 'inherit' to adopt the parent's background color.
 *
 * If no color is specified, the default background color will be var(--color-bg-light).
 */
export enum StickyFooterBackgroundColor {
  DEFAULT = 'default',
  INHERIT = 'inherit',
}
